import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		flex: 0 0 30.5px;
		padding: 0 4px;
		border-bottom: 1px solid var(--og-border-color);
		background-color: var(--og-header-bg-color);
		font-weight: bold;
		font-size: 12px;
	}

	.header-title {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.body {
		flex: 1;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.section {
		border-bottom: 1px solid var(--og-border-color);
	}

	.section-header {
		display: flex;
		align-items: center;
		gap: 4px;
		padding: 4px 8px;
		font-weight: bold;
		font-size: 11px;
		background-color: var(--og-accent-bg-color);
		color: var(--og-accent-color);
	}

	.section-header.collapsible {
		cursor: pointer;
		user-select: none;
	}

	.section-count {
		font-weight: normal;
		color: var(--og-secondary-color);
	}

	.section-count::before {
		content: "(";
	}

	.section-count::after {
		content: ")";
	}

	:host([compact]) .actions {
		flex-direction: row;
	}

	:host([compact]) .actions og-button {
		flex: 1 1 0;
		min-width: 0;
	}

	.parameter-row {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 4px 8px;
		min-height: 28px;
		border-bottom: 1px solid var(--og-border-color-light);
	}

	.parameter-label {
		flex: 0 0 40%;
		font-size: 11px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.parameter-value {
		flex: 1;
		min-width: 0;
	}

	.parameter-value rp-custom-parameter {
		height: 20px;
	}

	.csv-section .parameter-row {
		min-height: 26px;
	}

	.column-list {
		padding: 0;
		margin: 0;
		list-style: none;
	}

	.column-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 2px 8px;
		font-size: 11px;
		border-bottom: 1px solid var(--og-border-color-light);
	}

	.column-name {
		flex: 1;
	}

	.column-type {
		flex: 0 0 auto;
		color: var(--og-secondary-color);
	}

	.actions {
		padding: 8px;
		display: flex;
		flex-direction: column;
		gap: 4px;
	}

	.validation {
		display: flex;
		flex-direction: column;
		gap: 4px;
		padding: 0 8px 8px;
	}

	.validation og-alert {
		font-size: 11px;
		padding: 4px 6px;
	}

	.validation-hint {
		display: flex;
		align-items: center;
		gap: 4px;
		font-size: 11px;
		color: var(--og-secondary-color);
	}

	og-overlay {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;
